define([
    'jquery',
    'globalVars',
    'matchSize',
    'underscore',
    'Oggetto_SalonLocatorFrontend/js/get-dadata-geolocation.babel',
], ($, { $body, $window, $document }, matchSize, _, getDadata) => {
    const salonsMap = {
        element: $('#location_map'),

        options: {
            defaultZoom: 13,
            academieApiUrl: window.academyApiUrl,
            academySalonSearchUrl: window.academySalonSearchUrl,
            brandName: window.brandName,
            limit: window.limit,
            page: 1,
        },

        init() {
            if (!this.element.length) {
                return;
            }

            this.initCache();
            this.initEvents();
            this.getPosition();
        },

        initCache() {
            this.baloonTemplate = _.template($('#map_baloon_template').html());
        },

        initEvents() {
            $body.on(
                'click',
                '.js-gtm-salon-data',
                this.gtmSalonData.bind(this)
            );
        },

        getPosition() {
            getDadata
                .getIpLocationRequest()
                .done(response => {
                    if (response.location) {
                        this.lat = response.location.data.geo_lat;
                        this.lng = response.location.data.geo_lon;
                        this.city = response.location.data.city;

                        ymaps.ready(() => {
                            this.create();
                        });
                    }
                })
                .fail((jqXHR, textStatus, errorThrown) => {
                    console.log(
                        `К сожалению, произошла ошибка. Обновите страницу и повторите попытку.\nОшибка:${errorThrown}`
                    ); /* eslint-disable-line no-console */
                });
        },

        create() {
            this.map = new ymaps.Map(
                'location_map',
                {
                    center: [this.lat, this.lng],
                    zoom: this.options.defaultZoom,
                    controls: ['zoomControl'],
                    behaviors: ['default'],
                },
                {
                    searchControlProvider: 'yandex#search',
                    suppressMapOpenBlock: true,
                    yandexMapDisablePoiInteractivity: true,
                }
            );

            if (window.isPhone) {
                this.map.behaviors.disable('drag');
            }

            this.map.panes.get('controls')._zIndex = 600;

            const salonSearchHomeInput = 'salonSearchHomeInput';
            const $salonSearchHomeInput = $(`#${salonSearchHomeInput}`);
            const $closeIcon = $salonSearchHomeInput
                .parent()
                .find('.js-clear-input');

            this.balloonLayout = ymaps.templateLayoutFactory.createClass(
                `
            <div class="popover top">
                <a class="closeballoon" href="#"></a>
                <div class="arrow"></div>
                $[[options.contentLayout]]
            </div>
            `,
                {
                    build() {
                        this.constructor.superclass.build.call(this);
                        this._$element = $('.popover', this.getParentElement());
                        this.applyElementOffset();
                        this._$element
                            .find('.closeballoon')
                            .on('click', $.proxy(this.onCloseClick, this));
                    },

                    clear() {
                        this._$element.find('.closeballoon').off('click');
                        this.constructor.superclass.clear.call(this);
                    },

                    onSublayoutSizeChange() {
                        balloonLayout.superclass.onSublayoutSizeChange.apply(
                            this,
                            arguments
                        );

                        if (!this._isElement(this._$element)) {
                            return;
                        }

                        this.applyElementOffset();

                        this.events.fire('shapechange');
                    },

                    applyElementOffset() {
                        this._$element.css({
                            left: -(this._$element[0].offsetWidth / 2),
                            top: -(
                                this._$element[0].offsetHeight +
                                this._$element.find('.arrow')[0].offsetHeight
                            ),
                        });
                    },

                    onCloseClick(e) {
                        e.preventDefault();
                        this.events.fire('userclose');

                        $salonSearchHomeInput.fadeIn();
                        $closeIcon.fadeIn();
                    },

                    getShape() {
                        if (!this._isElement(this._$element)) {
                            return balloonLayout.superclass.getShape.call(this);
                        }

                        const position = this._$element.position();

                        return new ymaps.shape.Rectangle(
                            new ymaps.geometry.pixel.Rectangle([
                                [position.left, position.top],
                                [
                                    position.left +
                                        this._$element[0].offsetWidth,
                                    position.top +
                                        this._$element[0].offsetHeight +
                                        this._$element.find('.arrow')[0]
                                            .offsetHeight,
                                ],
                            ])
                        );
                    },

                    _isElement(element) {
                        return (
                            element && element[0] && element.find('.arrow')[0]
                        );
                    },
                }
            );

            this.balloonContentLayout = ymaps.templateLayoutFactory.createClass(
                '<span class="popover-title">$[properties.balloonContent]</span>'
            );

            this.map.geoObjects.events.add('balloonopen', e => {
                $salonSearchHomeInput.fadeOut();
                $closeIcon.fadeOut();
            });

            this.clusterer = new ymaps.Clusterer();
            this.clusterer.options.set('preset', 'islands#blackClusterIcons');

            this.map.geoObjects.add(this.clusterer);

            // Hardcode for salons Persona on /french-balayage
            if (!$('#inputContainer').length) {
                this.city = 'Москва';
                this.chain_slug = 'persona';

                this.getSalons(
                    '37.336329',
                    '37.984523',
                    '55.568321',
                    '55.801074',
                    () => {
                        this.map.setBounds(this.map.geoObjects.getBounds(), {
                            checkZoomRange: true,
                            zoomMargin: 10,
                        });
                    }
                );

                return;
            }

            this.boundsHandlerFunc();

            this.map.events.add('boundschange', () => {
                if (this.map.balloon.isOpen()) {
                    return;
                }

                this.boundsHandlerFunc();
            });

            this.initSuggest();
        },

        boundsHandlerFunc() {
            const boundsArray = this.map.getBounds();
            const [[min_lat, min_lon], [max_lat, max_lon]] = boundsArray;

            this.clusterer.removeAll();

            this.getSalons(min_lon, max_lon, min_lat, max_lat);
        },

        getSalons(min_lon, max_lon, min_lat, max_lat, updateMapFunction) {
            const url = this.getSalonsUrl(min_lon, max_lon, min_lat, max_lat);

            $.ajax({
                method: 'GET',
                url,
            })
                .done(data => {
                    if (data.salons.length) {
                        this.salons = data.salons;

                        this.appendPlacemarks();

                        if (updateMapFunction) {
                            updateMapFunction();
                        }
                    } else {
                        this.isEmpty(true);

                        console.log(
                            'No salon items found.'
                        ); /* eslint-disable-line no-console */
                    }
                })
                .fail((xhr, status, errorThrown) => {
                    console.log(
                        `An error occurred on the server. Please try to place the order again${errorThrown}`
                    ); // eslint-disable-line no-console
                });
        },

        getSalonsUrl(min_lon, max_lon, min_lat, max_lat) {
            let url =
                this.options.academieApiUrl +
                this.options.academySalonSearchUrl +
                '?brand=' +
                this.options.brandName +
                '&limit=' +
                this.options.limit +
                '&min_lon=' +
                min_lon +
                '&min_lat=' +
                min_lat +
                '&max_lon=' +
                max_lon +
                '&max_lat=' +
                max_lat +
                '&offset=0' +
                '&city=' +
                this.city;

            if (this.chain_slug) {
                url = `${url}&chain_slug=${this.chain_slug}`;
            }

            if (window.requestParams) {
                url = `${url}&${window.requestParams}`;
            }

            return url;
        },

        appendPlacemarks() {
            if (this.salons.length) {
                for (let i = 0; i < this.salons.length; i++) {
                    this._createPlacemark(i + 1, this.salons[i]);
                }
            }
        },

        _createPlacemark(index, item) {
            if (this.chain_slug && this.chain_slug === 'persona') {
                if (
                    item.id !== 61740 &&
                    item.id !== 92833 &&
                    item.id !== 33249 &&
                    item.id !== 24036 &&
                    item.id !== 64601 &&
                    item.id !== 68751 &&
                    item.id !== 1135
                ) {
                    return;
                }
            }

            if (item.socials.instagram) {
                item.socials.instagram_name =
                    item.socials.instagram.split('.com/')[1];
            }

            if (item.phone && item.phone.length > 17) {
                item.phone = item.phone.split(',')[0];
            }

            const properties = {
                balloonContent: this.baloonTemplate(item),
                preset: 'twirl#blackIcon',
            };

            const options = {
                balloonShadow: false,
                balloonLayout: this.balloonLayout,
                balloonContentLayout: this.balloonContentLayout,
                balloonPanelMaxMapArea: 0,
                iconLayout: 'default#image',
                iconImageHref: this.element.data('pin-img'),
                iconImageSize: [30, 30],
                iconImageOffset: [-15, -30],
            };

            if (item.geo_lat && item.geo_lon) {
                const placemark = new ymaps.Placemark(
                    [parseFloat(item.geo_lat), parseFloat(item.geo_lon)],
                    properties,
                    options
                );

                this.clusterer.add(placemark);
            }
        },

        initSuggest() {
            const $inputContainer = $('#inputContainer');
            const $clearInput = $('.js-clear-input');
            const salonSearchHomeInput = 'salonSearchHomeInput';
            const $salonSearchHomeInput = $(`#${salonSearchHomeInput}`);

            if (!$salonSearchHomeInput.length) {
                return;
            }

            const unhighlightClass = '_unhighlight-first-suggest-item';
            const hiddenClass = 'hidden';
            const arrowKeyCodes = [38, 40];
            const suggestView = new ymaps.SuggestView(salonSearchHomeInput);

            $clearInput.on('click', () => {
                $salonSearchHomeInput.val('').focus();
            });

            $salonSearchHomeInput.on('keyup focusin', ev => {
                if (arrowKeyCodes.indexOf(ev.keyCode) !== -1) {
                    $inputContainer.addClass(unhighlightClass);

                    return;
                }

                if ($(ev.target).val()) {
                    $clearInput.removeClass(hiddenClass);
                } else {
                    $clearInput.addClass(hiddenClass);
                }

                $inputContainer.removeClass(unhighlightClass);

                setTimeout(() => {
                    suggestView.state.set('activeIndex', 0);
                }, 200);
            });

            suggestView.events.add('select', ev => {
                const query = ev.originalEvent.item.displayName;

                $document.triggerHandler('salonLocator:find', ev.originalEvent.item.value);
                suggestView.state.set('request', query);

                ymaps
                    .geocode(query, { result: 1 })
                    .then(this.processGeoResult.bind(this));
            });
        },

        processGeoResult(result) {
            const geoObj = result.geoObjects.get(0);
            const arrPos = geoObj.geometry.getCoordinates();

            this.lat = arrPos[0];
            this.lng = arrPos[1];
            this.city = geoObj.properties._data.name;

            this.map.setCenter(arrPos, this.options.defaultZoom);
        },

        setDataLayer(salon, name, action, label) {
            if (typeof dataLayer === 'undefined' || !salon) {
                return;
            }

            dataLayer.push({
                event: 'uaevent',
                eventCategory: 'salon locator',
                eventAction: action,
                eventLabel: label,
                event_name: name,
                store_name: salon,
            });
        },

        gtmSalonData(event) {
            const $target = $(event.currentTarget);

            this.setDataLayer(
                $target.data('gtm-salon'),
                $target.data('gtm-name'),
                $target.data('gtm-action'),
                $target.data('gtm-label')
            );
        },
    };

    return {
        initialised: false,
        mapApiLoaded: false,

        run() {
            if ($('body').hasClass('cms-salon-search-iframe')) {
                this.initRun();

                return;
            }

            this.initLazyRun();
        },

        initRun() {
            if (this.mapApiLoaded) {
                return;
            }

            this.loadApi(() => this.initMap());

            this.mapApiLoaded = true;
        },

        initLazyRun() {
            const observer = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    this.initRun();
                }
            });

            observer.observe(document.querySelector('#salonLocatorSection'));
        },

        initMap() {
            if (this.initialised) {
                return;
            }

            salonsMap.init();

            this.initialised = true;

            $('.js-scroll-to-map').show();

            $body.on('click', '.js-scroll-to-map', this.scrollToMap);
        },

        scrollToMap(e) {
            e.preventDefault();

            $('html, body').animate(
                {
                    scrollTop: $('#salonLocatorSection').offset().top,
                },
                'slow'
            );
        },

        loadApi(callback) {
            const script = document.createElement('script');

            script.src = `https://api-maps.yandex.ru/2.1/?apikey=${salonsMap.element.data(
                'api-key'
            )}&lang=ru-RU`;
            script.onload = callback;

            document.body.appendChild(script);
        },
    };
});
